module.exports = __webpack_public_path__ + "img/3447944-1.8ba24ac8.jpg";